const StorageKey = Object.freeze({
	UserCredentials: 'drills-credentials',
	PreferredLanguage: 'drills-preferred-language',
	Theme: 'drills-theme',
});

export default StorageKey;
